import { combineReducers } from 'redux';

import { listings } from './listings';
import { cities } from './cities';

const reducer = combineReducers({
  listings,
  cities,
});
export { reducer };
